<template>
	<form method="POST" class="contact-form" novalidate  @submit.prevent="validateForm">
		<div class="form-row">
			<div class="form-group col-md-6">
				<label for="first_name">First Name <span class="text-danger">*</span></label>
				<input v-model="form.first_name" type="text" name="first_name" placeholder="First Name" class="form-control" :class="getValidationClass('first_name')" id="first_name" />
				<div class="invalid-feedback" v-if="!$v.form.first_name.required">Please enter your first name</div>
			</div>
			<div class="form-group col-md-6">
				<label for="last_name">Last Name <span class="text-danger">*</span></label>
				<input v-model="form.last_name" type="text" name="last_name" placeholder="Last Name" class="form-control" :class="getValidationClass('last_name')" id="last_name" />
				<div class="invalid-feedback" v-if="!$v.form.last_name.required">Please enter your last name</div>
			</div>
		</div>
		<div class="form-row">
			<div class="form-group col-md-6">
				<label for="email">Email <span class="text-danger">*</span></label>
				<input v-model="form.email" type="email" placeholder="Email" class="form-control" :class="getValidationClass('email')" name="email" id="email" />
				<div class="invalid-feedback" v-if="!$v.form.email.required">Please enter your email</div>
				<div class="invalid-feedback" v-else-if="!$v.form.email.email">Please enter a valid email</div>
			</div>
			<div class="form-group col-md-6">
				<label for="phone_number">Phone <span class="text-danger">*</span></label>
				<input v-model="form.phone_number" type="text" placeholder="Phone Number" class="form-control" :class="getValidationClass('phone_number')" name="phone_number" id="phone_number" />
				<div class="invalid-feedback" v-if="!$v.form.phone_number.required">Please enter your phone number</div>
			</div>
		</div>
		<div class="form-group">
			<label for="message">Message <span class="text-danger">*</span></label>
			<textarea v-model="form.message" placeholder="Message" class="form-control" :class="getValidationClass('message')" name="message" rows="10"></textarea>
			<div class="invalid-feedback" v-if="!$v.form.message.required">Please enter your message</div>
			<div class="invalid-feedback" v-else-if="!$v.form.message.maxLength">Please enter a message less than 500 characters</div>
		</div>
		<div class="form-row align-items-center">
			<div class="form-group col-md-6 mb-2 pb-1" :class="getValidationClass('captcha')" style="overflow: hidden;">
				<div class="d-flex justify-content-center">
					<vue-recaptcha @verify="form.captcha = $event" @expired="form.captcha = null" :sitekey="recaptchaKey" :loadRecaptchaScript="true"></vue-recaptcha>
				</div>
				<span class="invalid-feedback text-center" v-if="!$v.form.captcha.required">Please complete the captcha</span>
				<span class="invalid-feedback text-center" v-else-if="serverErrors.captcha">{{ serverErrors.captcha[0] }}</span>
			</div>
			<div class="form-group text-right col-md-6">
				<button type="button" class="btn btn-primary" :disabled="isLoading || $v.form.$error" @click="validateForm">Send Message</button>
			</div>
		</div>
		<Spinner v-if="isLoading"/>
	</form>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import validateMixin from '@app/mixins/validation';
	import { required, email, maxLength } from 'vuelidate/lib/validators';
	import VueRecaptcha from 'vue-recaptcha';

	export default {
		name: 'ContactForm',
		mixins: [validationMixin, validateMixin],
		data() {
			return this.initalFormState();
		},
		computed: {
			recaptchaKey() {
				return process.env.MIX_RECAPTCHA_SITE_KEY;
			},
		},
		components: {
			VueRecaptcha,
			Spinner: () => import('@app/components/Util/Spinner'),
		},
		validations: {
			form: {
				first_name: {
					required,
					maxLength: maxLength(100),
				},
				last_name: {
					required,
					maxLength: maxLength(100),
				},
				email: {
					required,
					maxLength: maxLength(100),
				},
				phone_number: {
					required,
					maxLength: maxLength(11),
				},
				message: {
					required,
					maxLength: maxLength(500)
				},
				captcha: {
					required
				}
			},
		},
		methods: {
			initalFormState() {
            	return {
            		isLoading: false,
					serverErrors: [],
					form: {
						first_name: null,
						last_name: null,
						email: null,
						phone_number: null,
						message: null,
						captcha: null,
					}
            	}
            },
			saveData () {
				this.isLoading = true;
				axios.post('contact', this.form)
				.then(response => {
					this.isLoading = false;
					Object.assign(this.$data, this.initalFormState());
					this.$v.$reset();
					this.$notify({
	                    title: 'Message Sent',
	                    type: 'success',
	                    duration: 5000,
	                    text: 'Message sent successfully! We will be in touch within 24 hours'
	                });
				}).catch(error => {
					this.isLoading = false;
					swal('Error', 'An error occurred while trying to submit your contact request. Please try again later.', 'error');
				})
			},
		}
	};
</script>

<style scoped>
	.is-invalid > .invalid-feedback { display: block; }
</style>
